<div class="p-10 h-full">
    <nz-page-header class="text-[16px] font-semibold p-0 m-0" nzTitle="Motivos de pausa">
        <nz-page-header-extra class="flex items-center justify-items-end">
            <!------------------------------------------------>
            <!------------------- FILTER INPUT --------------->
            <div class="flex">
                <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="inputClearTpl"
                    class="rounded-lg border border-gray-300">
                    <input onfocus="select()"
                        class="block px-4 text-[15px] font-medium py-1 pl-10 w-[275px] text-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Nombre del motivo de pausa" nz-input [(ngModel)]="filterText"
                        (keyup.enter)="getPaginatedPauseReasons()" />
                </nz-input-group>
                <ng-template #inputClearTpl>
                    @if (filterText) {
                    <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="clearFilter()"
                        nz-icon></span>
                    }
                </ng-template>
                <ng-template #searchIcon>
                    <span nz-icon nzType="search"></span>
                </ng-template>
            </div>
            @if (canCreate()) {
            <div class="flex">
                <button class="ml-1 button primary-button" (click)="create()">
                    @if(innerWidth > WIDTH_VIEW_LIST_COMPONENT_ACTIONS){
                    Nuevo
                    }@else {
                    <span nz-icon nzType="plus"></span>
                    }
                </button>
            </div>
            }
        </nz-page-header-extra>
    </nz-page-header>

    <div #tableContainer class="mt-[15px] h-[calc(100%_-_100px)] max-h-[calc(100%_-_100px)]">
        <nz-table #pauseReasonsTable nzTableLayout="fixed" [nzSize]="'small'" [nzData]="pauseReasons"
            [nzLoading]="isLoading" [nzLoadingIndicator]="indicatorTemplate" [nzTotal]="totalPauseReasons"
            [nzBordered]="true" [nzFrontPagination]="false" [nzScroll]="{ y: (tableHeight || 0) + 'px', x:'240px' }"
            nzShowSizeChanger [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
            (nzQueryParams)="onQueryParamsChange($event)">
            <thead>
                <tr>
                    <th nzWidth="200px">Nombre</th>
                    <th nzWidth="200px">Tiempo estimado</th>
                    <th nzWidth="200px">Por defecto </th>
                    <th nzWidth="200px">Máquinas asignadas </th>
                    <th nzWidth="200px">Utilizado en </th>
                    @if (canRead() || canEdit() || canDelete()) {
                    <th nzRight nzWidth="150px">Acciones</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (pauseReason of pauseReasonsTable.data; track pauseReason.id) {
                <tr>
                    <td>{{ pauseReason.name }}</td>
                    <td>{{ calculateMillisToHHmmss(pauseReason.timeStimated) }}</td>
                    <td>{{ pauseReason.isDefault ? 'Sí' : 'No' }}</td>
                    <td>{{ pauseReason._count?.machines ?? 0 }} {{pauseReason._count?.machines &&
                        pauseReason._count?.machines === 1 ? 'máquina' : 'máquinas'}}</td>
                    <td>{{ pauseReason._count?.productionPauses ?? 0 }} {{pauseReason._count?.productionPauses &&
                        pauseReason._count?.productionPauses === 1 ? 'pausa' : 'pausas'}}</td>
                    @if (canRead() || canEdit() || canDelete()) {
                    <td nzRight>
                        <div class="flex align-middle justify-center">
                            @if (canRead()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Ver motivo de pausa'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="view(pauseReason)">
                                <span nz-icon nzType="eye"></span>
                            </button>
                            @if (canEdit() || canDelete()) {
                            <nz-divider nzType="vertical"></nz-divider>
                            }
                            }
                            @if (canEdit()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Editar motivo de pausa'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="edit(pauseReason)">
                                <span nz-icon nzType="edit"></span>
                            </button>
                            @if (canDelete()) {
                            <nz-divider nzType="vertical"></nz-divider>
                            }
                            }

                            @if (canDelete()) {
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Eliminar motivo de pausa'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="delete(pauseReason.id!)">
                                <span nz-icon nzType="delete"></span>
                            </button>
                            }
                        </div>
                    </td>
                    }
                </tr>
                }
            </tbody>
        </nz-table>
    </div>
</div>

<ng-template #indicatorTemplate>
    <app-loader></app-loader>
</ng-template>

<nz-drawer [nzClosable]="false" [nzVisible]="drawerVisible" nzPlacement="right" [nzTitle]="title" [nzFooter]="footer"
    (nzOnClose)="closeDrawer()" [nzPlacement]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'right':'bottom'"
    [nzWidth]="'70%'" [nzHeight]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? '' : '90%'"
    [nzMaskClosable]="fieldsReadOnly">
    <ng-template #title class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
        <div style="display: flex; align-items: center;">
            <p class="drawer-title"> {{ drawerTitle }} </p>
        </div>
    </ng-template>
    <ng-container *nzDrawerContent>
        <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()" class="h-full">
            <nz-tabset [nzTabPosition]="innerWidth > DRAWER_WIDTH_CHANGE_PLACEMENT ? 'left' : 'top'" class="h-full">
                <nz-tab nzTitle="Datos">
                    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="p-4">
                        <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                            <nz-form-label nzRequired>
                                Nombre
                            </nz-form-label>
                            <nz-form-control nzErrorTip="Indique un nombre para el motivo de la pausa">
                                <input onfocus="select()" nz-input placeholder="Indique un nombre para el motivo de la pausa"
                                    type="text" id="name" formControlName="name" />
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                            <nz-form-control>
                                <label nz-checkbox id="isDefault"
                                    formControlName="isDefault">¿Usar por defecto?</label>
                            </nz-form-control>
                        </nz-form-item>
                        <nz-form-item nz-col nzXs="24" nzSm="24" nzMd="24" class="px-4">
                            <nz-form-label nzRequired>
                                Tiempo estimado de la pausa (HH:mm:ss)
                            </nz-form-label>
                            <nz-form-control>
                                <nz-input-group>
                                    <div nz-row [nzGutter]="8">
                                        <div nz-col nzSpan="8">
                                            <input onfocus="select()" nz-input
                                                nzErrorTip="Indique los horas con un valor mayor que 0"
                                                placeholder="Indique las horas de la " type="number" id="hours"
                                                formControlName="hours" />
                                        </div>
                                        <div nz-col nzSpan="8">
                                            <input onfocus="select()" nz-input
                                                placeholder="Indique los minutos con un valor mayor que 0 y menor que 59"
                                                type="number" id="minutes" formControlName="minutes" />
                                        </div>
                                        <div nz-col nzSpan="8">
                                            <input onfocus="select()" nz-input
                                                placeholder="Indique los segundos con un valor mayor que 0 y menor que 59"
                                                type="number" id="seconds" formControlName="seconds" />
                                        </div>
                                    </div>
                                </nz-input-group>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </nz-tab>
                <nz-tab [nzTitle]="'Máquinas ('+(pauseReasonSelected?.machines ? pauseReasonSelected?.machines?.length : 0)+')'">
                    <nz-form-item nz-col class="px-4">
                        <nz-form-label>
                            Máquinas vinculadas
                        </nz-form-label>
                        <nz-form-control [hidden]="fieldsReadOnly">
                            <nz-transfer
                                class="mb-5"
                                [nzDataSource]="machinesTransferItems"
                                [nzDisabled]="fieldsReadOnly"
                                [nzTitles]="['Disponibles', 'Asignadas']"
                                [nzFilterOption]="filterOptionsTransferMachines"
                                nzShowSearch
                            >
                            </nz-transfer>
                        </nz-form-control>
                    </nz-form-item>
                    <nz-table #machinesTable [nzData]="pauseReasonSelected?.machines ?? []" class="px-4 pb-4"
                        nzTableLayout="auto" nzSize="small" [nzFrontPagination]="false" [nzShowPagination]="false"
                        [nzBordered]="true" [hidden]="!fieldsReadOnly">
                        <thead>
                            <tr>
                                <th>Máquina</th>
                                @if (!fieldsReadOnly) {
                                <th>Acciones</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (machine of machinesTable.data; let idx = $index; track idx) {
                            <tr>
                                <td>{{ machine.name }}</td>
                                @if (!fieldsReadOnly) {
                                <td class="text-center">
                                    <div class="flex align-middle justify-center">
                                        <button nz-button type="button" nzType="text" nzShape="circle" class="table-icon">
                                            <!--(click)="deleteEntryArticleFeature(articleFeatureValue.frontId!)">-->
                                            <span nz-icon nzType="delete"></span>
                                        </button>
                                    </div>
                                </td>
                                }
                            </tr>
                            }
                        </tbody>
                    </nz-table>
                </nz-tab>
            </nz-tabset>

        </form>
    </ng-container>
    <ng-template #footer>
        <div class="flex justify-end">
            <button class="button secondary-button mr-2" (click)="closeDrawer()">
                Cancelar
            </button>

            @if (!fieldsReadOnly) {
                <button nz-button class="button primary-button" [disabled]="!validateForm.valid" (click)="submitForm()" [nzLoading]="isSaving">
                    Guardar
                </button>
            }
        </div>
    </ng-template>
</nz-drawer>